import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsMobile = (
  slug,
  dispatch,
  translate,
  updateServiceGroupStatus,
  handleSortChange,
  isMobile,
  hasAccessToEdit
) => {
  return [
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("serviceGroup.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      // width: 400,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        return (
          <HStack gap={2}>
            <Stack gap={0}>
              <Text
                fontSize="15px"
                color={textPrimary}
                fontWeight="600"
                textAlign="left"
                isTruncated // This will add ellipsis
                // maxW="360px"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: false,
      Cell: ({ row }) => {
        const { status, _id } = row.original;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateServiceGroupStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              p="0"
              minW="100px"
              h="2.25rem"
              fontSize="xs"
              // isUnclickable={!hasAccessToEdit}
              isUnclickable={true}
            />
          </HStack>
        );
      },
    },
  ];
};
